import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Injectable, inject } from '@angular/core';

@Injectable()
export class ProjectreTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);


  override updateTitle(routerState: RouterStateSnapshot) {
    const title = this.buildTitle(routerState);
    if (title !== undefined) {
      this.title.setTitle(`ProjectRE - ${title}`);
    }
  }
}
